import axios from 'axios';

// Create API instance
const api = axios.create({
  baseURL: UD_URL,
});

api.defaults.headers.common['Content-Type'] = 'application/json; charset=utf-8';
api.defaults.headers.common['dataType'] = 'json'; // eslint-disable-line dot-notation

api.interceptors.response.use(
  response => response.data,
  error => Promise.reject(error),
);

// API functions
function login(credentials) {
  const inviteCodeQuery = credentials.inviteCode
    ? `?inviteCode=${credentials.inviteCode}`
    : '';

  return api.post(`/security/auth${inviteCodeQuery}`, credentials, {
    headers: {
      Accept: 'application/x.za.co.logbox+json; version=2',
      ClientType: 'PRACTICE_BROCHURE',
    },
  })
    .then((data) => {
      // Redirect to other application
      window.location.href = data.location;
    });
}

function isAccountLocked(credentials) {
  return api.get(`/security/${credentials.username}/lockedstatus`);
}

function register(user) {
  return api.post('registration/register', user, {
    headers: { Accept: 'application/x.za.co.logbox+json; version=2' },
  })
    .then((data) => {
      window.location.href = data.location;
    });
}

function requestPasswordReset(username) {
  return api.post('/security/password/requestReset', username, {
    headers: { Accept: 'application/x.za.co.logbox+json; version=2' },
  });
}

function performPasswordResetWithOtp(credentialsWithOtp) {
  return api.post('/security/password/processResetWithOtp', credentialsWithOtp)
    .then((data) => {
      window.location.href = data.location;
    });
}

function requestUsernameReminder(email) {
  return api.post('/security/username/requestReminder', email);
}

function performPasswordReset(credentials) {
  return api.post('/security/password/processReset', credentials);
}

function sendContactRequest(contactMeCriteria) {
  return api.post('/brochure/contactRequest', contactMeCriteria);
}

function lookupCountries() {
  return api.get('/lookup/countries');
}

function lookupDisciplines() {
  return api.get('/lookup/disciplines');
}

function lookupSpecialities(disciplineId) {
  return api.get(`/lookup/discipline/${disciplineId}/specialities`);
}

function lookupRoles(specialityId) {
  return api.get(`/lookup/speciality/${specialityId}/roles`);
}

function fetchPracticeInviteData(inviteKey) {
  return api.get(`invite/${inviteKey}`);
}

function fetchPracticeNameAutocomplete(searchText) {
  return api.get(`/practice/search?name=${searchText}`);
}

function fetchPracticeKioskLink(practiceId) {
  return api.get(`/practice/kiosk-link/${practiceId}`);
}

async function validateAccountDeletionToken(token) {
  return api.get(`/profile/deleterequest/validate/${token}`);
}
async function deleteAccount(userId, token) {
  return api.post(`/profile/deleterequest/${userId}/delete/${token}`);
}

export default {
  login,
  isAccountLocked,
  register,
  requestPasswordReset,
  performPasswordResetWithOtp,
  requestUsernameReminder,
  performPasswordReset,
  sendContactRequest,
  lookupCountries,
  lookupDisciplines,
  lookupSpecialities,
  lookupRoles,
  fetchPracticeInviteData,
  fetchPracticeNameAutocomplete,
  fetchPracticeKioskLink,
  validateAccountDeletionToken,
  deleteAccount,
};



// WEBPACK FOOTER //
// ./src/api/Ud.js